import styled from 'styled-components/macro';
import { ButtonLink } from '@yme/molecules/buttons';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
export const TitleStyled = styled.div `
  margin-bottom: ${INDENT.xxxs};
`;
export const SubtitleStyled = styled.div `
  margin-bottom: ${INDENT.sm};
`;
export const TextBlockStyled = styled.div `
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  ${ADAPTIVE.minWidth.desktop} {
    max-width: 660px;
    margin: 0 auto;
  }
`;
export const ButtonStyled = styled.div `
  margin-top: ${INDENT.sm};
  width: auto;
`;
export const ButtonLinkStyled = styled(ButtonLink) `
  & > span {
    display: inline-block;
  }
`;
